export const ROLES = {
  super_user: 'SUPER_USER',
  owner: 'OWNER',
  administrator: 'ADMINISTRATOR',
  user: 'USER',
  viewer: 'VIEWER',
  applier: 'APPLIER',
  reporter: 'REPORTER',
  unset: 'NOT_SET',
} as const;

export const SCOPES = {
  canCreate: 'can-create',
  canEdit: 'can-edit',
  canDelete: 'can-delete',
  canView: 'can-view',
} as const;

export const ADMINISTRATORS = {
  owner: 'OWNER',
  administrator: 'ADMINISTRATOR',
} as const;
